import { SBCRewardType } from "@/api/privateRequests/sbcs/getSbcSets";
import { ImageWithFallback } from "@/components/ImageWithFallback";
import { PlatformChoice } from "@/components/organisms/SBCs/PlatformChoice/PlatformChoice";
import { Tier } from "@/redux/players/playersSlice";

import { SBCRequirements } from "../SBCRequirements";
import { SBCReward } from "../SBCReward";

type Props = {
  name: string;
  imageURL: string;
  reward: SBCRewardType;
  rewardUrl: string;
  playerRole: string;
  tier: Tier;
  description?: string;
  requirements: string[];
  formattedPrice: string;
  sbcToggle: React.ReactNode;
  platform: "Playstation" | "PC";
  isOnSolutionsPage: boolean;
};

const SBCMobile = ({
  name,
  imageURL,
  reward,
  rewardUrl,
  playerRole,
  tier,
  description,
  requirements,
  formattedPrice,
  sbcToggle,
  platform,
  isOnSolutionsPage,
}: Props) => {
  if (isOnSolutionsPage) {
    return (
      <div className="cursor-auto">
        <div className="flex px-4 py-3 items-center">
          <ImageWithFallback
            className="h-14 w-14 -ml-4 -mr-1 -mb-1 "
            src={imageURL}
            alt={imageURL + "image"}
            fallback={
              import.meta.env.VITE_APP_ASSETS_BASE_URL + "/misc/default-sbc.png"
            }
          />
          <div className="w-full">
            <div className="flex justify-between items-center h-5">
              <div className="text-sm">{name}</div>
              <div className="flex items-center">{sbcToggle}</div>
            </div>
            <div className="flex items-center gap-1 h-5">
              <img
                className="w-3 h-3 desktop:w-[12px] desktop:h-[12px]"
                src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc24/misc/fc24coin.png`}
                alt="ut-coin"
              />
              <span className="text-xs text-dark-primary font-medium">
                {formattedPrice}
              </span>
              <PlatformChoice platform={platform} />
            </div>
          </div>
        </div>
        <div className="">
          <div className="bg-panel-middleground mx-4 mb-1 p-2 rounded-t-lg">
            <SBCRequirements requirements={requirements} />
          </div>
          <div className="bg-panel-middleground m-4 mt-0 rounded-b-lg">
            <SBCReward
              reward={reward}
              rewardUrl={rewardUrl}
              playerRole={playerRole}
              tier={tier}
              description={description}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="border-t-2 border-t-panel-foreground p-4">
      <div className="flex justify-between">
        <div className="flex items-center">
          <ImageWithFallback
            loading="lazy"
            className="h-12 w-12 object-cover object-center"
            src={imageURL}
            alt={name}
            fallback={
              import.meta.env.VITE_APP_ASSETS_BASE_URL + "/misc/default-sbc.png"
            }
          />
          <div>
            <div className="font-bold">{name}</div>
            <div className="flex items-center gap-x-1">
              <img
                className="w-3 h-3 desktop:w-[17px] desktop:h-[17px]"
                src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc24/misc/fc24coin.png`}
                alt="ut-coin"
              />
              <span className="font-xs text-dark-secondary">
                {formattedPrice}
              </span>
              <PlatformChoice platform={platform} />
            </div>
          </div>
        </div>
        <div className="flex items-center">{sbcToggle}</div>
      </div>

      <div className="bg-panel-background rounded-lg mt-2">
        <div className="p-4">
          <SBCRequirements requirements={requirements} />
        </div>
        <div className="border-1 border-panel-base" />
        <div className="p-4">
          <SBCReward
            reward={reward}
            rewardUrl={rewardUrl}
            playerRole={playerRole}
            tier={tier}
            description={description}
          />
        </div>
      </div>
    </div>
  );
};

export default SBCMobile;
